<sk-modal-content [title]="'label.versionMismatchModalTitle' | translate"
                  [isHideCross]="true"
                  [cancelBtnText]="'label.Reload' | translate "
                  (closed)="reloadPage()">

  <ng-container id="sk-modal-body">
    <p>{{ 'message.ReloadThepageMessage' | translate }}</p>
    <p>{{ 'message.ReloadThepageMessageNote' | translate }}</p>
  </ng-container>
</sk-modal-content>
